import { Component, OnInit } from '@angular/core';
import { Searchgeneral } from 'src/app/model/searchgeneral.model';
import { UserService } from 'src/app/services/user/user.service';
import { NgForm } from '@angular/forms';
import { RoleService } from 'src/app/services/role/role.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { Vendorregistration } from 'src/app/model/vendorregistration.model';
import * as fileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { ExportButtonRendererComponent } from 'src/app/exportbutton-renderer.component';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
@Component({
  selector: 'app-addpurchaselines',
  templateUrl: './addpurchaselines.component.html',
  styleUrls: ['./addpurchaselines.component.css']
})
export class AddpurchaselinesComponent implements OnInit {

  clipExistBool: boolean = false;
  selectedRowsCount = 0;
  showclientlinkdropdown = false;
  showclientlinkdropdownForOldVendor = false;
  showQuotaSurveyLinkForSingle = false;
  searchGeneral: Searchgeneral;
  vendreg: Vendorregistration;
  projectid: string;
  countryid: string;
  vendorName: String;
  langid: string;
  projectDetails: any;
  data: any;
  dataL: any;
  projectCalcCountryLanguageList: any;
  projCalcId: string;
  clientLinkData: any;
  dataV: any;

  // IMPORTANT: this is an array, not a function
  sentryVendorList: any[] = [];
  vendorDropdownList: any[] = [];

  countryData: any;
  set: string;
  className: string;
  num: number;
  languageData: any;
  showDataBool: boolean = false;
  isListLoading: boolean = false;
  textBoxBool: boolean = true;
  vendDropDown: boolean = true;
  multiple: boolean = false;
  isLoadings: boolean = false;
  securityId: number | undefined;
  clientLinkId: number;
  projectcalculationId: number;
  rowData: any;
  frameworkComponents: any
  private gridApi;
  private gridColumnApi;
  clientLinkType: string;
  columnDefs = [
    { headerName: '#', field: '', width: 10, headerCheckboxSelection: false, checkboxSelection: true },
    { headerName: "Client Link", width: 350, field: "clientLink", filter: true, sortable: true, resizable: true },
    { headerName: "Vendor", field: "vendorName", filter: true, sortable: true, resizable: true },
  ];

  columnDefsformultiple = [
    { headerName: '#', field: '', width: 10, headerCheckboxSelection: false, checkboxSelection: true },
    { headerName: "Country", width: 100, field: "countryName", filter: true, sortable: true, resizable: true },
    { headerName: "Language", width: 100, field: "language", filter: true, sortable: true, resizable: true },
    { headerName: "Vendor", width: 100, field: "vendorName", filter: true, sortable: true, resizable: true },
    { headerName: "Assigned Links", width: 100, field: "assignedLinks", filter: true, sortable: true, resizable: true },
    {
      headerName: 'Export',
      cellRenderer: 'exportButtonRenderer',
      width: 200,
      cellRendererParams: {
        onClick: this.exportLinksMultiple.bind(this),
        label: 'Export'
      },
    },
  ];

  defaultColDef = {
    minWidth: 50,
  };

  gridOptions = {
    isRowSelectable: (rowNode: any) => {
      return rowNode.data && rowNode.data.vendorName == null;
    }
  };
  constructor(private userService: UserService, private route: ActivatedRoute, private router: Router, private roleservice: RoleService, private toastr: ToastrService) {
    this.projectid = this.route.snapshot.params.projectid;
    this.countryid = this.route.snapshot.params.countryid;
    this.langid = this.route.snapshot.params.langid;
    this.set = this.route.snapshot.params.set;
    this.num = this.route.snapshot.params.num;

    this.frameworkComponents = {
      exportButtonRenderer: ExportButtonRendererComponent,
    }

    const urlSegments = this.router.url.split('/').filter(s => s);
    const lastSegment = urlSegments.pop();
    console.log('Current URL segment:', lastSegment); // e.g., "oldassignvendorclip"

    if (lastSegment == 'oldassignvendorclip') {
      this.showclientlinkdropdownForOldVendor = false;
    } else {
      this.showclientlinkdropdownForOldVendor = true;
    }

  }

  ngOnInit() {
    debugger
    this.securityId = Number(localStorage.getItem('securityId')) || null;
    this.clientLinkId = Number(localStorage.getItem('clientLinkId')) || null;
    this.projectcalculationId = Number(localStorage.getItem('projectCalculationId')) || null;
    this.vendreg = new Vendorregistration();
    if (this.set == "multiple") {
      this.multiple = true;
      //console.log("number" , this.route.snapshot.params.num)
      this.vendreg.unassignsurveylink = this.num;
    }
    this.textBoxBool = true;
    this.searchGeneral = new Searchgeneral();
    // this.vendreg = new Vendorregistration();
    this.GetSentryVendorList();
    this.getCountryList();
    this.getLanguageList();
    if (!this.showclientlinkdropdown) {
      this.getVendorList(this.projectid, this.countryid, this.langid);
    }

    if (this.projectid != undefined) {
      this.textBoxBool = false;
      this.vendreg.country = this.countryid;
      this.vendreg.language = this.langid;
      this.vendreg.projectCalcCountryLanguage = this.projCalcId;
      debugger
      this.roleservice.SearchProjectInfoDetails(this.projectid).subscribe(
        (data: any) => {
          this.projectDetails = data;
          if (this.projectDetails.length === 0) {
            this.showDataBool = false;
          }
          else {
            //this.projectid = this.projectDetails[0].projectId;
            this.showDataBool = true;
          }
        }
      )
    }


  }

  getCountryList() {
    debugger;
    this.userService.getCountryList().subscribe(
      (data) => {
        this.countryData = data;
        this.data = this.countryData;
        //console.log("user data" + this.data);
      }
    )
  }

  exportLinksMultiple(param) {
    this.userService.getMultipleLinkDataToExport(param.data, this.projectid)
      .subscribe((data: any) => {
        if (data) {
          this.DownloadExcel(data);
        }
        else {
          this.toastr.error("No Data To Export", '', { progressBar: true });
        }
      });
  }

  DownloadExcel(data: any) {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, "Multiple Links");
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    fileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  onGridReady(params: any) {
    debugger
    this.gridApi = params.api;
  }

  getLanguageList() {
    debugger;
    this.userService.getLanguageList().subscribe(
      (data) => {
        this.languageData = data;
        this.dataL = this.languageData;
        //console.log("user data" + this.dataL);
      }
    )
  }
  SubmitSearchListForm(form: NgForm) {
    debugger;
    this.isListLoading = true;
    this.showclientlinkdropdown = true
    this.roleservice.SearchProjectDetails(this.searchGeneral).subscribe(
      (data: any) => {
        this.isListLoading = false;
        this.projectDetails = data;
        this.clientLinkType = this.projectDetails[0].clintLinkType;
        if (this.projectDetails.length === 0) {
          this.showDataBool = false;
          this.toastr.error("No items found", '', { progressBar: true });
        }
        else {
          this.roleservice.GetCountryLanguageList(this.searchGeneral).subscribe(
            (data: any) => {
              console.log(data);
              this.data = data;
            }
          )
          this.projectid = this.projectDetails[0].projectID;
          this.vendreg.country = this.projectDetails[0].countryID;
          this.vendreg.country = "";
          this.vendreg.language = this.projectDetails[0].languageID;
          this.vendreg.language = "";
          this.vendreg.projectCalcCountryLanguage = "";
          this.vendreg.projSecurityId = "";
          this.vendreg.vendorclip = "";
          this.showDataBool = true;
          this.textBoxBool = true;
          this.set = "single";
          this.vendreg.vendorname = "-1";
          this.vendreg.VendCompRedirectURL = "";
          this.vendreg.VendTermRedirectURL = "";
          this.vendreg.VendQFRedirectURL = "";
          this.vendreg.VendQCRRedirectURL = "";

          this.vendreg.totalQuota = "";
          this.vendreg.originalSurveyLink = "";

        }
        if (this.projectDetails[0].clintLinkType == "multiple") {
          this.className = "clipButtonMultiple";
          this.multiple = true;
          this.vendreg.vendorname = "-1";
          this.vendreg.VendCompRedirectURL = "";
          this.vendreg.VendTermRedirectURL = "";
          this.vendreg.VendQFRedirectURL = "";
          this.vendreg.VendQCRRedirectURL = "";
          this.set = "multiple";
        }
        else {
          this.className = "clipButton";
          this.multiple = false;
        }
        console.log(this.projectDetails);
      }
    )
  }

  getVendorList(projectId, countryId, languageId) {
    if (this.showclientlinkdropdownForOldVendor == false) {
      this.roleservice.getVendorDetails().subscribe(
        (data: any) => {
          this.dataV = data;


          console.log(this.dataV)
          if (this.dataV.length === 0) {
          }
          else {
          }
        }
      )
    } else {
      this.roleservice.getUsedVendorDetails(projectId, countryId, languageId).subscribe(
        (data: any) => {
          debugger;
          this.dataV = data;
          console.log(this.dataV)
        }
      )
    }
  }

  // GetSentryVendorList(){
  //    this.roleservice.GetSentryVendorList().subscribe()
  // }

  // ------------------------------------
  // Get Vendor Provider List
  // ------------------------------------
  GetSentryVendorList(): void {
    debugger;
    this.roleservice.GetSentryVendorList().subscribe(
      (response: any) => {

        console.log('Vendor Provider List:', response);

        this.sentryVendorList = response;

        // Check matching records
        this.highlightMatchingVendors();


      },
      (error) => {

        console.error('Error getting vendor provider list:', error);

      }
    );
  }

  // ------------------------------------
  // Check whether vendor exists
  // in VendorProviderList
  // ------------------------------------
// highlightMatchingVendors() {
//     debugger;

//     if (!this.dataV || !this.sentryVendorList) {
//         return;
//     }

//     this.vendorDropdownList = [];

//     for (let i = 0; i < this.dataV.length; i++) {
//         const vendor = this.dataV[i];
//         let matched = false;

//         for (let j = 0; j < this.sentryVendorList.length; j++) {
//             const provider = this.sentryVendorList[j];

//             const vendorName = String(vendor.vendorName || '').trim().toLowerCase();
//             const providerName = String(provider.name || '').trim().toLowerCase();

//             const vendorId = String(vendor.providerId || '').trim().toLowerCase();
//             const providerId = String(provider.providerId || '').trim().toLowerCase();

//             console.log({
//                 vendorName,
//                 providerName,
//                 vendorId,
//                 providerId,
//                 nameMatch: vendorName === providerName,
//                 idMatch: vendorId === providerId
//             });

//             if (
//                 vendorName === providerName &&
//                 vendorId === providerId
//             ) {
//                 matched = true;
//                 break;
//             }
//         }

//         this.vendorDropdownList.push({
//             id: vendor.id,
//             vendorName: vendor.vendorName,
//             providerId: vendor.providerId,
//             matched: matched
//         });
//     }

//     console.log('FINAL DROPDOWN:', this.vendorDropdownList);
// }

highlightMatchingVendors(): void {
  if (!this.dataV || !this.sentryVendorList) {
    this.vendorDropdownList = [];
    return;
  }

  // Create a Set containing all matching vendor name + providerId combinations
  const matchedVendors = new Set<string>();

  this.sentryVendorList.forEach(provider => {
    const providerName = this.normalize(provider.name);
    const providerId = this.normalize(provider.providerId);

    matchedVendors.add(
      this.createVendorKey(providerName, providerId)
    );
  });

  // Build dropdown list
  this.vendorDropdownList = this.dataV.map(vendor => {
    const vendorName = this.normalize(vendor.vendorName);
    const vendorId = this.normalize(vendor.providerId);

    const key = this.createVendorKey(vendorName, vendorId);

    return {
      id: vendor.id,
      vendorName: vendor.vendorName,
      providerId: vendor.providerId,
      matched: matchedVendors.has(key)
    };
  });

  console.log('FINAL DROPDOWN:', this.vendorDropdownList);
}

private normalize(value: any): string {
  return String(value || '')
    .trim()
    .toLowerCase();
}

private createVendorKey(name: string, providerId: string): string {
  return name + '|' + providerId;
}




  OnSubmit(form: NgForm) {

    if (this.showclientlinkdropdownForOldVendor == false) {
      if (this.set != "multiple") {
        this.isLoadings = true;
        var url = window.location.href;
        url = url.replace("oldassignvendorclip", "StartSurvey");
        if (this.langid != undefined) {
          form.value.langid = this.langid;
        }
        else {
          //form.value.langid = this.projectDetails[0].languageID;
          form.value.langid = this.vendreg.language;
        }
        if (this.countryid != undefined) {
          form.value.countryid = this.countryid;
        }
        else {
          // form.value.countryid = this.projectDetails[0].countryID;
          form.value.countryid = this.vendreg.country;
        }
        form.value.projectid = this.projectid;
        form.value.securityId = this.securityId;
        form.value.projectcalculationId = this.vendreg.projectCalcCountryLanguage;
        form.value.ClientlinkId = this.clientLinkId;
        form.value.url = url;
        console.log(form.value);

        this.userService.checkIfClipExist(form.value).subscribe(
          (data: boolean) => {
            //debugger;
            if (data) {
              this.isLoadings = false;
              this.toastr.error("Provided vendor clip is already assigned for selected project.", '', { progressBar: true });
            }
            else {
              this.userService.addOldVendorClipData(form.value, this.securityId, this.clientLinkId, this.vendreg.projectCalcCountryLanguage)
                .subscribe((data: any) => {
                  if (data != null && data != undefined) {
                    this.router.navigate(['/viewprojectdetails/' + this.projectid]);
                  }
                  this.isLoadings = false;
                });


            }

          }
        );
      }
      else if (this.set == "multiple") {
        this.isLoadings = true;
        // alert("hello world")
        if ((parseInt(form.value.assignlink) > this.num) || (parseInt(form.value.assignlink) > this.vendreg.unassignsurveylink)) {
          this.toastr.error("Assigned Links cannot be greater than Remaining Links", '', { progressBar: true });
          this.isLoadings = false;
        }
        else {
          var url = window.location.href;
          url = url.replace("oldassignvendorclip", "StartSurvey");
          if (this.langid != undefined) {
            form.value.langid = this.langid;
          }
          else {
            //form.value.langid = this.projectDetails[0].languageID;
            form.value.langid = this.vendreg.language;
          }
          if (this.countryid != undefined) {
            form.value.countryid = this.countryid;
          }
          else {
            // form.value.countryid = this.projectDetails[0].countryID;
            form.value.countryid = this.vendreg.country;
          }
          form.value.projectid = this.projectid;
          form.value.projectcalculationId = this.vendreg.projectCalcCountryLanguage;
          form.value.projectcalculationId = this.vendreg.projectCalcCountryLanguage;
          form.value.projectSecurityId = this.vendreg.projSecurityId;
          form.value.url = url;
          form.value.vendorclip = form.value.vendorclip ? form.value.vendorclip : this.vendreg.vendorclip;
          console.log(form.value);

          this.userService.checkIfClipExist(form.value).subscribe(
            (data: boolean) => {
              //debugger;
              if (data) {
                this.toastr.error("Provided vendor clip is already assigned for selected project.", '', { progressBar: true });
                this.isLoadings = false;
              }
              else {
                this.userService.addVendorClipDataForMultiple(form.value, this.num, form.value.projectSecurityId, this.clientLinkId, this.vendreg.projectCalcCountryLanguage)
                  .subscribe((data: any) => {
                    if (data != null && data != undefined) {
                      this.router.navigate(['/viewprojectdetails/' + this.projectid]);
                    }
                    this.isLoadings = false;
                  });


              }

            }
          );
        }
      }
    } else {

      if (this.showclientlinkdropdown) {
        const selectedRows = this.gridApi.getSelectedRows();
        if (this.clientLinkType == 'multiple') {
          const projectcalculation = selectedRows.map(row => row.projectCalculationID);
          this.projectcalculationId = projectcalculation[0]
          const vendor = selectedRows.map(row => row.vendorName);
          this.vendorName = vendor[0]

          if (this.vendorName == undefined || this.vendorName == null || this.vendorName == "") {
            this.num = this.vendreg.unassignsurveylink
            console.log("traiil", this.num + " " + this.vendorName)
          }
        }
        else {
          const client = selectedRows.map(row => row.clientLinkID);
          this.clientLinkId = client[0]
        }
        const projectsId = selectedRows.map(row => row.projectSecurityId);
        this.securityId = projectsId[0]
      }
      debugger;

      if (this.set != "multiple") {
        this.isLoadings = true;
        var url = window.location.href;
        url = url.replace("assignvendorclip", "StartSurvey");
        if (this.langid != undefined) {
          form.value.langid = this.langid;
        }
        else {
          //form.value.langid = this.projectDetails[0].languageID;
          form.value.langid = this.vendreg.language;
        }
        if (this.countryid != undefined) {
          form.value.countryid = this.countryid;
        }
        else {
          // form.value.countryid = this.projectDetails[0].countryID;
          form.value.countryid = this.vendreg.country;
        }
        form.value.projectid = this.projectid;
        form.value.url = url;
        console.log(form.value);

        this.userService.checkIfClipExist(form.value).subscribe(
          (data: boolean) => {
            //debugger;
            if (data) {
              this.isLoadings = false;
              this.toastr.error("Provided vendor clip is already assigned for selected project.", '', { progressBar: true });
            }
            else {
              this.userService.addVendorClipData(form.value, this.securityId, this.clientLinkId, this.projectcalculationId)
                .subscribe((data: any) => {
                  if (data != null && data != undefined) {
                    localStorage.removeItem('securityId');
                    localStorage.removeItem('clientLinkId');
                    localStorage.removeItem('projectCalculationId');
                    this.router.navigate(['/viewprojectdetails/' + this.projectid]);
                  }
                  this.isLoadings = false;
                });


            }

          }
        );
      }
      else if (this.set == "multiple") {
        this.isLoadings = true;
        // alert("hello world")
        if ((parseInt(form.value.assignlink) > this.num) || (parseInt(form.value.assignlink) > this.vendreg.unassignsurveylink)) {
          this.toastr.error("Assigned Links cannot be greater than Remaining Links", '', { progressBar: true });
          this.isLoadings = false;
        }
        else {
          var url = window.location.href;
          url = url.replace("assignvendorclip", "StartSurvey");
          if (this.langid != undefined) {
            form.value.langid = this.langid;
          }
          else {
            //form.value.langid = this.projectDetails[0].languageID;
            form.value.langid = this.vendreg.language;
          }
          if (this.countryid != undefined) {
            form.value.countryid = this.countryid;
          }
          else {
            // form.value.countryid = this.projectDetails[0].countryID;
            form.value.countryid = this.vendreg.country;
          }
          form.value.projectid = this.projectid;
          form.value.url = url;
          form.value.vendorclip = form.value.vendorclip ? form.value.vendorclip : this.vendreg.vendorclip;
          console.log(form.value);

          this.userService.checkIfClipExist(form.value).subscribe(
            (data: boolean) => {
              //debugger;
              if (data) {
                this.toastr.error("Provided vendor clip is already assigned for selected project.", '', { progressBar: true });
                this.isLoadings = false;
              }
              else {
                this.userService.addVendorClipDataForMultiple(form.value, this.num, this.securityId, this.clientLinkId, this.projectcalculationId)
                  .subscribe((data: any) => {
                    if (data != null && data != undefined) {
                      localStorage.removeItem('securityId');
                      localStorage.removeItem('clientLinkId');
                      localStorage.removeItem('projectCalculationId');
                      this.router.navigate(['/viewprojectdetails/' + this.projectid]);
                    }
                    this.isLoadings = false;
                  });


              }

            }
          );
        }
      }
    }
  }

  changeVendor(event) {
    console.log(event.target.value);
    console.log(this.dataV);
    if (event.target.value == 0) {
      this.router.navigate(['/vendorregistration']);
    }
    else {
      for (var i = 0; i < this.dataV.length; i++) {
        if (event.target.value == this.dataV[i].id) {
          this.vendreg.VendCompRedirectURL = this.dataV[i].vendorSC;
          this.vendreg.VendTermRedirectURL = this.dataV[i].vendorST;
          this.vendreg.VendQFRedirectURL = this.dataV[i].vendorSQF;
          this.vendreg.VendQCRRedirectURL = this.dataV[i].vendorSQCR;
        }
      }
    }
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

  }

  standardChange(event) {
    this.vendDropDown = true;
  }
  adhocChange(event) {
    this.vendreg.vendorname = "";
    this.vendDropDown = false;
  }

  languageChange(event) {
    debugger
    this.vendreg.language = null;
    this.dataL = [];
    if (this.langid == undefined && this.countryid == undefined) {
      this.userService.GetLangList(this.projectid, this.vendreg.country).subscribe(
        (data: any) => {
          console.log(data);
          this.dataL = data;
        }
      )
    }
  }

  getclientlinkData(projectId, countryId, languageId) {
    debugger
    this.userService.GetUsedLinks(projectId, countryId, languageId).subscribe(
      (data: any) => {
        this.clientLinkData = data;
        this.rowData = data;
      })
    console.log("Project Id : ", projectId, "CountryId : ", countryId, "languageId :", languageId)
  }

  GetSurveyLinkDataForMultiple(projectId, countryId, languageId) {
    debugger;
    this.roleservice.GetUsedLinksForMultiple(projectId, countryId, languageId).subscribe(
      (data: any) => {
        this.clientLinkData = data;
        this.rowData = data;
      }
    )
  }
  onSelectionChanged(event: any) {
    debugger
    const selectedRows = event.api.getSelectedRows();
    this.selectedRowsCount = selectedRows.length;
    if (this.clientLinkType == "multiple") {
      if (selectedRows.length > 0) {
        this.getunassignedLink(this.projectid, selectedRows[0].countryId, selectedRows[0].languageID, selectedRows[0].projectCalculationID);
      }
      else {
        this.vendreg.unassignsurveylink = 0;
        console.log("Not Selected");
      }
    }
  }

  projectCalcCountryLangChangeEvent() {

    this.userService.GetUnassignedLink(this.projectid, this.vendreg.country, this.vendreg.language, this.vendreg.projectCalcCountryLanguage).subscribe(
      (data: any) => {
        console.log(data);
        if (data) {
          var remainLinKCount = 0;
          var clientLinkId = 0;
          for (var i = 0; i < data.length; i++) {
            remainLinKCount = remainLinKCount + data[i].remainingLinks;
            clientLinkId = data[i].clientLinkId;
          }
          this.vendreg.unassignsurveylink = remainLinKCount;
          this.clientLinkId = clientLinkId;
          this.userService.getSecurityIdFromProjectCalculation(this.vendreg.projectCalcCountryLanguage, this.projectid).subscribe(
            (data: any) => {
              console.log(data);
              if (data) {
                this.vendreg.projSecurityId = data.projectSecurityId;
                this.securityId = data.projectSecurityId;

                // if (data.clintLinkType == "single") {
                this.showQuotaSurveyLinkForSingle = true;
                this.vendreg.totalQuota = data.totalTarget;
                this.userService.getClientLinkIdFromClientLink(data.projectSecurityId, data.clientLinkKey, data.countryID, data.languageID, data.projectID).subscribe(
                  (data: any) => {
                    console.log(data);
                    if (data) {
                      this.vendreg.originalSurveyLink = data.clientLink;
                    }
                  })
                // }
              }
            })

        }
      }
    )
  }
  languageChangeEvent(event) {
    if (this.showclientlinkdropdownForOldVendor == false) {
      if (this.projectDetails[0].clintLinkType == "multiple" && this.vendreg.country) {
        // this.userService.GetUnassignedLink(this.projectid, this.vendreg.country, this.vendreg.language, this.projectcalculationId).subscribe(
        //   (data: any) => {
        //     console.log(data);
        //     if (data) {
        //       var remainLinKCount = 0;
        //       for (var i = 0; i < data.length; i++) {
        //         remainLinKCount = remainLinKCount + data[i].remainingLinks;
        //       }
        //       this.vendreg.unassignsurveylink = remainLinKCount;
        //     }
        //   }
        // )

        this.userService.getAllProjectCalculationByLangCountry(this.projectid, this.vendreg.country, this.vendreg.language, "multiple").subscribe((data: any) => {
          console.log(data);
          this.projectCalcCountryLanguageList = data;
        })

      }
      else {
        this.userService.getAllProjectCalculationByLangCountry(this.projectid, this.vendreg.country, this.vendreg.language, "").subscribe((data: any) => {
          console.log(data);
          this.projectCalcCountryLanguageList = data;
        })

        // this.userService.getAllProjectCalculationByLangCountry(this.projectid, this.vendreg.country, this.vendreg.language).subscribe((data: any) => {
        //   console.log(data);
        //   // this.projectCalcCountryLanguageList = data;
        //   this.clientLinkId = data.clientLinkId;
        //   this.vendreg.projectCalcCountryLanguage =data.projCalcId;
        //   this.projectcalculationId= data.projCalcId;
        //   this.vendreg.projSecurityId = data.projSecurityId;
        //   this.securityId = data.projSecurityId;

        // })

      }
    } else {
      if (this.showclientlinkdropdown) {
        if (this.clientLinkType == "multiple") {
          this.GetSurveyLinkDataForMultiple(this.projectid, this.vendreg.country, this.vendreg.language);
        }
        else {
          if (this.showclientlinkdropdownForOldVendor) {
            this.getclientlinkData(this.projectid, this.vendreg.country, this.vendreg.language);
          }
        }
        this.getVendorList(this.projectid, this.vendreg.country, this.vendreg.language);
      }
      if (this.projectDetails[0].clintLinkType == "multiple" && this.vendreg.country) {
        if (!this.showclientlinkdropdown) {
          this.getunassignedLink(this.projectid, this.vendreg.country, this.vendreg.language, this.projectcalculationId);
        }
      }
    }
  }
  getunassignedLink(projctId, countryId, languageId, projectCalculationId) {
    this.userService.GetUnassignedLink(projctId, countryId, languageId, projectCalculationId).subscribe(
      (data: any) => {
        debugger
        console.log(data);
        if (data) {
          var remainLinKCount = 0;
          for (var i = 0; i < data.length; i++) {
            remainLinKCount = remainLinKCount + data[i].remainingLinks;
          }
          this.vendreg.unassignsurveylink = remainLinKCount;
        }
      }
    )
  }
}
